export default __webpack_public_path__ + "static/media/Head_4_Ear_3_C4.34f2fb50.svg";